import { SelectItem } from "primeng/api";

enum SystemCodeType {
    OSIICS = 1,
    SNOMED,
    OSIICSSNOMED
}

const SystemCodeTypeMap: Record<SystemCodeType, string> = {
    1: "OSIICS",
    2: "SNOMED",
    3: "OSIICS and SNOMED"
};

function createOptions() {
    return Object.keys(SystemCodeTypeMap)
        .map(k => +k as SystemCodeType)
        .map(k => <SelectItem>{ value: k, label: SystemCodeTypeMap[k] });
}

export { SystemCodeType, SystemCodeTypeMap, createOptions };
